// Web shim over @skills-marketplace/shared/search: re-exports the shared module and binds
// the two Official-CAI-aware functions to the web's `isOfficial` (official-cai.json), which
// the shared module takes as an injected dependency so that data file stays a web concern.

import { isOfficial } from "./official";
import {
  sortPlugins as sharedSortPlugins,
  filterPlugins as sharedFilterPlugins,
  type ComparatorSortBy,
  type SearchOptions,
} from "@skills-marketplace/shared/search";
import type { MarketplaceEntry } from "../types/index";

export * from "@skills-marketplace/shared/search";

// These shadow the same names from `export *` above, binding isOfficial so call sites
// keep their signatures.
export function sortPlugins(
  plugins: MarketplaceEntry[],
  sortBy: ComparatorSortBy = "name",
  sortOrder: "asc" | "desc" = "asc",
): MarketplaceEntry[] {
  return sharedSortPlugins(plugins, sortBy, sortOrder, isOfficial);
}

export function filterPlugins(
  plugins: MarketplaceEntry[],
  options: SearchOptions,
): MarketplaceEntry[] {
  return sharedFilterPlugins(plugins, options, isOfficial);
}
